import SupportTile from './SupportTile';
export default SupportTile;
